export default {
  isLoading: false,
  error: false,
  errorMessage: null,
  termofservices: [],
  termofservice: {}
};
